"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundNumber = exports.SurplusLabelMap = exports.getTaxAndFeeDisplayLabels = exports.calculateTotal = exports.surplusLineOptions = exports.getIsDisabled = void 0;
var types_1 = require("./types");
var getIsDisabled = function (option, value) {
    var _a;
    var surplusLines = value.surplusLines;
    return (_a = surplusLines === null || surplusLines === void 0 ? void 0 : surplusLines.map(function (line) { return line.item; }).includes(option)) !== null && _a !== void 0 ? _a : false;
};
exports.getIsDisabled = getIsDisabled;
exports.surplusLineOptions = [
    { label: 'Inspection fee', value: types_1.SurplusLineItem.INSPECTION_FEE, isDisabled: false },
];
var calculateTotal = function (value) {
    var sum;
    if (value.surplusLines) {
        sum = value.surplusLines.map(function (fee) { return fee.value; }).reduce(function (partialSum, a) { return (partialSum !== null && partialSum !== void 0 ? partialSum : 0) + (a !== null && a !== void 0 ? a : 0); }, 0);
    }
    return (value.premium +
        value.stateTax +
        value.stateStampingFee +
        value.miscTaxesAndFees +
        value.carrierPolicyFee +
        value.newfrontFee +
        value.wholesaleFee +
        (sum !== null && sum !== void 0 ? sum : 0));
};
exports.calculateTotal = calculateTotal;
var getTaxAndFeeDisplayLabels = function (stateInfo) {
    if (!stateInfo)
        return { taxLabel: 'State surplus lines tax', feeLabel: 'State surplus lines fee' };
    var stateName = stateInfo.stateName, stateTax = stateInfo.stateTax, stateFee = stateInfo.stateFee;
    if (!stateTax && !stateFee) {
        return {
            taxLabel: "".concat(stateName, " surplus lines tax"),
            feeLabel: "".concat(stateName, " surplus lines fee"),
        };
    }
    return {
        taxLabel: stateTax > 0
            ? "".concat(stateName, " surplus lines tax - ").concat(Number((stateTax * 100).toFixed(4)), "%")
            : "".concat(stateName, " surplus lines tax - 0%"),
        feeLabel: stateFee > 0
            ? "".concat(stateName, " surplus lines fee - ").concat(Number((stateFee * 100).toFixed(4)), "%")
            : "".concat(stateName, " surplus lines fee - 0%"),
    };
};
exports.getTaxAndFeeDisplayLabels = getTaxAndFeeDisplayLabels;
exports.SurplusLabelMap = {
    INSPECTION_FEE: 'Inspection fee',
};
function roundNumber(num, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 2; }
    return Math.round(num * Math.pow(10, decimalPlaces) + Number.EPSILON) / Math.pow(10, decimalPlaces);
}
exports.roundNumber = roundNumber;
//# sourceMappingURL=util.js.map